const _ = require("lodash");
const unlockData = require("../../../shared/data/dbUnlockLevel.json");
const TrainerCore = require("../../../shared/TrainerCore");
const AT = require("../vault/ActionTypes");

const getAllUnlockedAtLevel = function(level) {
	return unlockData[level];
};

// Get everything that's unlocked between lower and upper level but not
// including lower level. (lower, upper]. Returns an object of array of items
// keyed by type.
// Ex: {spaces: ["lab"], puzzleTypes: [2, 3]}
const getAllUnlockedBetweenLevels = function(upper, lower) {
	const levels = _.filter(unlockData, (val, l) => l > lower && l <= upper);
	return _.reduce(levels, (res, val) => {
		return _.mergeWith(res, val, (r, v) => _.union(r, v));
	});
};

// Gets the level that the item unlocks at given an item type and the item ID
// or name. Can also pass a function that returns true if the item is what
// we're looking for.
const getUnlockLevel = function(type, item) {
	let level;
	if (typeof item === "function") {
		level = _.findKey(unlockData, l => {
			return _.find(l[type], item);
		});
	} else {
		level = _.findKey(unlockData, l => {
			return _.includes(l[type], item);
		});
	}
	if (level) return parseInt(level);
	else return 0;
};

// Get all unlocked item types (i.e. puzzle types, beast parts) on and before
// level.
const getAllUnlockedTypes = function(type, level) {
	const allUnlocked = getAllUnlockedBetweenLevels(level, 1);
	if (allUnlocked) return allUnlocked[type];
	else return [];
};

const isUnlockedByXP = function(type, item, xp) {
	if (!xp) return false;
	const level = TrainerCore.getLevel(xp);
	const unlockLevel = getUnlockLevel(type, item);
	return level >= unlockLevel;
};

const getLabLockUpdateFunction = function(dispatch, student, lockOverrides) {
	return dispatchInfo => {
		const unlockedByXP = isUnlockedByXP(
			"spaces",
			"lab",
			_.get(student, "user.studentData.xp")
		);
		const unlockedByOverride =
			_.get(lockOverrides, "lockData.spaces.lab.lockOverride") === "unlocked";
		const labTypeOrBlock =
			dispatchInfo.objectType === "labType" ||
			dispatchInfo.objectType === "labBlock";
		if (
			labTypeOrBlock &&
			!unlockedByXP &&
			!unlockedByOverride &&
			dispatchInfo.newValue === "unlocked"
		) {
			dispatchInfo.type = AT.UNLOCK_LAB_ITEM_BEFORE_LAB_UNLOCKED_REQUEST;
		}
		dispatch(dispatchInfo);
	};
};

module.exports = {
	getAllUnlockedAtLevel,
	getAllUnlockedBetweenLevels,
	getUnlockLevel,
	getAllUnlockedTypes,
	getLabLockUpdateFunction,
};
